import { TenantCodePage } from 'pages/TenantCodePage/TenantCodePage';
import { PaymentPage } from 'pages/Payment';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './styles/fonts.css';
import './styles/styles.css';
import Done from 'pages/Payment/done';
import ErrorPage from 'pages/error';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TenantCodePage />} />
        <Route path="/payment/:state" element={<PaymentPage />} />
        <Route path="/payment/done" element={<Done />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
